<template>
    <div class="signature-body" >
      
            <SignaturePad :terms=template.Body @cancel-event="onCancel" @agree-event="onAgree" ></SignaturePad>
     
        <CustomPopup :visible="showPopup"
                     :icon="popupIcon"
                     :iconSrc="popupIconSrc"
                     :iconColor="iconColor"
                     :title="popupTitle"
                     :content="content"
                     :cancelText="cancelText"
                     :confirmText="confirmText"
                     :confirmButtonType="confirmButtonType"
                     :confirmAction="currentConfirmAction"
                     @cancel="onCancel" />
    </div>
    
</template>

<script>
    import SignaturePad from '../components/SignaturePad.vue';
    import Swal from 'sweetalert2';

    import CustomPopup from '../components/modals/CustomPopup.vue';

    export default {
        name: "Signature-Pad",
        components: {
            SignaturePad, CustomPopup
        },
        data() {
            return {
                key: new URLSearchParams(window.location.search).get('key'),
                template: { Template: { Body: "" } },

                //Custom Popup
                showSignaturePad: false,
                showPopup: false,
                popupIcon: null, // Set to null since we'll use an image
                popupIconSrc: '', // Use this variable to hold the image path
                iconColor: '',
                popupTitle: '',
                content: '',
                cancelText: '',
                confirmText: '',
                confirmButtonType: 'primary',
                currentConfirmAction: null,
            }
        },
        mounted() {
            this.loadContract();
        },
        methods: {
            loadContract() {
                this.$loader.show(null, 30);
                this.$http.request("get", "/api/app/contract/preview3", {code:this.key}).then((res) => {

                    if (res?.Type == 200) {
                        this.showSignaturePad = true;
                        this.template = res.Data;
                    } else {
                        this.showSignaturePad = false;
                        this.showPopup = true;

                        this.iconColor = 'red';
                        this.popupIconSrc = require('@/assets/images/icons/ErrorIcon.png');

                        this.popupTitle = res.Content;
                        this.cancelText = null;
                        this.confirmText = 'OK';
                        this.confirmButtonType = 'error';
                        this.currentConfirmAction = () => {
                            this.$router.push('/');
                        };
                    }

                }).finally(() => {
                    this.$loader.hide();
                });
            },
            onAgree(imageFile) {
                //http://192.168.0.19:8080/Signature?key=97%2Fc%2F%2FBNm3vxcb70IZ3aSEzVZ8u1%2FX1VHL%2FewLnMT9wtOoOGtsoyTg%3D%3D
                //http://t2.cellflare.com/API/GCBuddy/Contracts/Code?code=97%2Fc%2F%2FBNm3vxcb70IZ3aSEzVZ8u1%2FX1VHL%2FewLnMT9wtOoOGtsoyTg%3D%3D
                var _this = this;
                if (null === imageFile) {

                    this.showPopup = true;
                     
                    //this.popupIcon = 'FieldTimeOutlined';
                    this.iconColor = 'red';
                    this.popupIconSrc = require('@/assets/images/icons/DeleteIcon.png'); // Replace with your image path
                    this.popupTitle = "";
                    this.content = "Please Provide your signature!";
                    this.cancelText = null;
                    this.confirmText = 'OK';
                    this.confirmButtonType = 'error';

                    this.currentConfirmAction = null;
                 }
                else {

                    this.showPopup = true;

                    //this.popupIcon = 'FieldTimeOutlined';
                    this.iconColor = 'red';
                    this.popupIconSrc = null; // Replace with your image path
                    this.popupTitle = "";
                    this.content = "Are you sure you want to sign this contract?";
                    this.cancelText = "Cancel";
                    this.confirmText = 'Confirm';
                    this.confirmButtonType = 'success';

                    this.currentConfirmAction = () => {
                        var data = {
                            code: this.key,
                            signature: null
                        }

                        _this.$loader.show(null, 30);

                        _this.$http.request("post", '/api/cloud/upload', imageFile).then(res => {
                            if (res?.Data != null) {
                                data.signature = res.Data;

                                _this.$loader.show(null, 30);

                                _this.$http.request("post", "/api/app/contract/sign", data).then((res2) => {

                                    if (res2?.Type == 200) {

                                        _this.showPopup = true;

                                        //this.popupIcon = 'FieldTimeOutlined';
                                        _this.iconColor = 'red';
                                        //_this.popupIconSrc = require('@/assets/images/icons/DeleteIcon.png'); // Replace with your image path
                                        _this.popupTitle = "Thank you!";
                                        _this.content = "Your contract has been signed.";
                                        _this.cancelText = null;
                                        _this.confirmText = 'OK';
                                        _this.confirmButtonType = 'success';

                                        _this.currentConfirmAction = () => {

                                            _this.showPopup = false;
                                            _this.$router.push('/');

                                        };


                                    }

                                }).finally(() => {
                                    _this.$loader.hide();
                                });

                            }
                        });
                    }

                   
                }
                
            },
            onCancel() {
                //this.$router.push('/');
                this.showPopup = false;
            }
        }

    }
</script>

<style scoped>
    .signature-body {
        background-color: #000000da;
        display: table;
        width: 100%;
        height: 100vh;
    }
</style>